export default __webpack_public_path__ + "static/media/shareBlueWhite.e91defb0.svg";